import { MyBHArticleCardProps } from "@components/Blocks/Card/MyBHArticle/MyBHArticleCard";
import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";

export default function mapArticleToMyBHArticleCardProps(
  article: ProcessedArticleData,
): MyBHArticleCardProps {
  return {
    title: article.title,
    articleUrlPath: article.urlPath || article.linkTo,

    image: {
      imageField: article.imageField,
      imageAlt: article.imageAlt,
    },

    sectionDetails: {
      linkToSection: article.linkToSection,
      sectionName: article.sectionName,
      parentSection: article.parentSection,
      uniqueSectionName: article.uniqueSectionName,
    },

    date: article.date,
    time: article.time,

    contentAccess: article.contentAccess,
    paragraph: article.paragraph,

    tags: article.tags?.map((tag) => ({
      alias: tag.alias ?? "",
      name: tag.name ?? "",
    })),

    authors: article.authors?.map((author) => ({
      name: author.name,
      urlPath: author.urlPath ?? "",
    })),
  };
}
